"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./controllers/admin-app-config-api"), exports);
__exportStar(require("./controllers/admin-auth-api"), exports);
__exportStar(require("./controllers/admin-awards-api"), exports);
__exportStar(require("./controllers/admin-category-api"), exports);
__exportStar(require("./controllers/admin-competition-api"), exports);
__exportStar(require("./controllers/admin-content-pages-api"), exports);
__exportStar(require("./controllers/admin-dashboard-api"), exports);
__exportStar(require("./controllers/admin-goodies-api"), exports);
__exportStar(require("./controllers/admin-notification-api"), exports);
__exportStar(require("./controllers/admin-referral-api"), exports);
__exportStar(require("./controllers/admin-submissions-api"), exports);
__exportStar(require("./controllers/app-config-api"), exports);
__exportStar(require("./controllers/auth-users-api"), exports);
__exportStar(require("./controllers/bookmarks-api"), exports);
__exportStar(require("./controllers/content-pages-api"), exports);
__exportStar(require("./controllers/health-api"), exports);
__exportStar(require("./controllers/home-api"), exports);
__exportStar(require("./controllers/notifications-user-api"), exports);
__exportStar(require("./controllers/onboarding-api"), exports);
__exportStar(require("./controllers/prometheus-api"), exports);
__exportStar(require("./controllers/public-competitions-api"), exports);
__exportStar(require("./controllers/public-submissions-api"), exports);
__exportStar(require("./controllers/reports-api"), exports);
__exportStar(require("./controllers/social-comments-api"), exports);
__exportStar(require("./controllers/social-likes-api"), exports);
__exportStar(require("./controllers/social-reports-api"), exports);
__exportStar(require("./controllers/social-stats-api"), exports);
__exportStar(require("./controllers/social-votes-api"), exports);
__exportStar(require("./controllers/uploads-api"), exports);
__exportStar(require("./controllers/user-blocks-api"), exports);
__exportStar(require("./controllers/user-competition-api"), exports);
__exportStar(require("./controllers/user-rewards-api"), exports);
__exportStar(require("./controllers/user-submissions-api"), exports);
__exportStar(require("./controllers/users-api"), exports);
__exportStar(require("./controllers/users-management-api"), exports);
__exportStar(require("./controllers/webhooks-bunny-api"), exports);
